import { memo } from 'react';
import { useOrderSettingTableDataLab } from 'shared-modules/hooks/select';
import { CommonTable } from './CommonTable';

export const LabTable = memo(() => {
  const { autoTradeSettingsData, helpers, loading } = useOrderSettingTableDataLab();
  return <CommonTable data={autoTradeSettingsData} helpers={helpers} loading={loading} />;
});
